const styles = theme => ({
  cardTitle: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  },
  vad:{
    width: '100%',
    [theme.breakpoints.up("md")]: {
      position: 'relative',
      bottom: 60,
    },
    [theme.breakpoints.down("md")]: {
      position: 'relative',
      bottom: 20,
    }
  },
  idadeInput:{
    '& .MuiOutlinedInput-root': {
      color: 'rgb(110, 110, 110)',
      '& fieldset': {
        borderColor: 'white',
      },
    }
  },
  errors:{
    color: 'red',
    fontWeight: 400,
    marginLeft: 20,
  },
  formControl:{
    width: 170,
    maxWidth: 170,
    [theme.breakpoints.down("md")]: {
      marginLeft: 15,
    },
  },
  alert: {
    margin: 20,
    textAlign: 'justify',
  },
});

export default styles
